import { Component, OnInit } from '@angular/core';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';


export class CustomModalContext extends BSModalContext {
  public modalData: any;
}
@Component({
  selector: 'app-message-detail',
  templateUrl: './message-detail.component.html',
  styleUrls: ['./message-detail.component.css']
})
export class MessageDetailComponent implements OnInit,  ModalComponent<CustomModalContext> {
  context: CustomModalContext;
  modalData: any;
  constructor(public dialog: DialogRef<CustomModalContext>, private modal: Modal, private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
      this.dialog.close();
      }
    });
  }

  ngOnInit() {
    this.modalData = this.dialog.context.modalData;
    this.modalData.Action = this.modalData.Action == undefined ? 'Continue' : this.modalData.Action;
  }
  continueClick() {
    this.dialog.context.modalData.next = 'yes';
    this.dialog.close();
  }
  closeClick() {
    this.dialog.context.modalData.next = 'no';
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/messagecenter/message-detail/message-detail.component.ts